const days = {
  sunday: 'dom',
  monday: 'seg',
  tuesday: 'ter',
  wednesday: 'qua',
  thursday: 'qui',
  friday: 'sex',
  saturday: 'sab'
}

export default (rule) => {
  const keys = Object.keys(rule)
  const label = keys.reduce((acc, key) => {
    if (rule[key] && days[key]) {
      acc.push(days[key])
    }

    return acc
  }, [])

  return label.join(', ')
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/resources/days.js